// outputNode.js

import { BaseNode } from './BaseNode';
import { Position } from 'reactflow';

export const OutputNode = ({ id, data }) => {
  const handles = [
    {
      type: 'target',
      position: Position.Left,
      id: `${id}-value`,
      style: { left: '-2px' }
    }
  ];

  const fields = [
    {
      name: 'outputName',
      label: 'Name',
      type: 'text',
      defaultValue: data?.outputName || id.replace('customOutput-', 'output_')
    },
    {
      name: 'outputType',
      label: 'Type',
      type: 'select',
      defaultValue: data.outputType || 'Text',
      options: [
        { value: 'Text', label: 'Text' },
        { value: 'File', label: 'Image' }
      ]
    }
  ];

  return (
    <BaseNode
      id={id}
      data={data}
      type="customOutput"
      title="Output"
      handles={handles}
      fields={fields}
    />
  );
};
